import urljoin from 'url-join'
import axios from 'axios'
import ServicesUtils from '@/utils/servicesUtils'


async function login (identifier, password, targetCityId, deviceRequestedFrom)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/login')
    const response = await axios.post(url, { identifier, password, targetCityId, deviceRequestedFrom })

    return response.data
}

async function logout (token)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/logout')
    const response = await axios.post(url, {}, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function getAccount (token)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/me')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function getAccountSettings (token)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/me/settings')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function updateAccountSettings (token, settings)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/me/settings')
    const response = await axios.patch(url, settings, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function getAccountStore (token)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/me/store')
    const response = await axios.get(url, { headers: { Authorization: `Bearer ${token}` } })

    return response.data
}

async function updateAccount (token, account, currentPassword)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/me')
    const response = await axios.patch(url, account, { headers: { Authorization: `Bearer ${token}` }, params: {currentPassword} })

    return response.data
}

/**
 * 
 * @param {string|number} accountId 
 */
async function recoverPassword (accountId)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts', accountId.toString(), 'recover-password')
    const response = await axios.post(url)

    return response.data
}

/**
 * 
 * @param {string|number} accountId 
 * @param {string} token 
 */
async function getPasswordRecoveryToken (accountId, token)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts', accountId.toString(), 'password-recovery-token', token)
    const response = await axios.get(url)

    return response.data
}

/**
 * 
 * @param {string|number} accountId 
 * @param {string} token 
 * @param {string} newPassword 
 */
async function usePasswordRecoveryToken (accountId, token, newPassword)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts', accountId.toString(), 'password-recovery-token', token)
    const response = await axios.post(url, {newPassword})

    return response.data
}

async function searchAccount (identifier, targetCityId)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/search', identifier.toString())
    const response = await axios.get(url, {params: { targetCityId }})

    return response.data
}

async function createAccount (accountData)
{
    let url = urljoin(ServicesUtils.apiUrl, 'accounts/create')
    const response = await axios.post(url, accountData)

    return response.data
}

export default { login, logout, getAccount, getAccountSettings, updateAccountSettings, getAccountStore, updateAccount,
    recoverPassword, getPasswordRecoveryToken, usePasswordRecoveryToken, searchAccount, createAccount }


// WEBPACK FOOTER //
// ./src/services/accounts.js